import React from 'react';
import Header from '../components/Header';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="h-screen w-full max-w-full overflow-hidden bg-bg text-text">
      {/* Top Navigation */}
      <Header />

      {/* Main Content */}
      <div className="h-full w-full max-w-full pt-20 overflow-auto">
        <div className="w-full max-w-full">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PublicLayout;
